'use strict'

import ServiceExec from "@/common/utils/ServiceExec";

class AssetSvc extends ServiceExec {
  getAssetReportData(params = {}) {
    return this.queryPost(`/api/app/asset/getAssetReportDataWeb`, params)
      .then(res => res.data)
  }

  getAssetData(params = {}) {
    return this.queryPost(`/api/app/asset/getAssetData`, params)
      .then(res => res.data)
  }

  getAssetList(params = {}) {
    return this.queryPost(`/api/app/asset/getAssetList`, params)
      .then(res => res.data)
  }
}
export default new AssetSvc()
